import { t } from "../../../i18n";
import { ButtonBase } from '@mui/material';
import { portalConfig } from '../../../configs/portal';
import logo from '../../../assets/images/logos/Logos CardioID/VersaoNegativo_HeartmetricsExperts_RGB.png';
export default function CompanySection() {
  return <ButtonBase component="a" href={portalConfig.companyUrl} target="_blank" rel="noopener noreferrer">
            <img src={logo} alt={t("CardioID — Heartmetrics Experts")} width="200" style={{
      maxWidth: '100%',
      height: 'auto'
    }} />
        </ButtonBase>;
}
